import React from 'react'
import SuccessMessageUI from '../../../../widgets/form/SuccessMessageUI'
import ErrorMessageUI from '../../../../widgets/form/ErrorMessageUI'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputTextUI from '../../../../widgets/form/InputTextUI'
import ButtonUI from '../../../../widgets/action/ButtonUI'
import './MoveToCsModal.css' // reuse same modal overlay styles

const AddCustomDocModalUI = ({
  context,
  addMode,
  compliance,       // 'cp' or 'cs'
  onCancelClick,
  //
  title,
  onTitleChange,
  dueDate,
  onDueDateChange,
  isPromoterLevel,
  onIsPromoterLevelChange,
  //
  submitted,
  successMsg,
  errorList,
  onSubmitClick
}) => {
  if (!addMode) return null

  const isCP = compliance === 'cp'
  const label = isCP ? 'Add Custom CP' : 'Add Custom CS'
  const heading = isCP ? 'Add Custom Condition Precedent' : 'Add Custom Condition Subsequent'

  return (
    <div className='move-to-cs-modal-overlay'>
      <div className='move-to-cs-modal-container'>

        <div className='move-to-cs-modal-header'>
          <h3>{heading}</h3>
          <button className='move-to-cs-modal-close' onClick={onCancelClick}>×</button>
        </div>

        <div className='move-to-cs-modal-body'>

          {/* Title */}
          <div className='g_m_bottom_100'>
            <InputTextUI
              context={context}
              name='title'
              label='Document Title'
              required={true}
              value={title}
              onChange={onTitleChange}
              placeholder='e.g. Custom CKYC Certificate'
              help='Human-readable name shown in the compliance list'
            />
          </div>

          {/* Due Date - show only for CS */}
          {!isCP && (
            <div className='g_m_bottom_100'>
              <InputDateUI
                context={context}
                name='dueDate'
                label='Due Date'
                required={false}
                selectedDateISO={dueDate}
                onChange={onDueDateChange}
                help='Leave blank if no due date applies'
              />
            </div>
          )}

          {/* Promoter level toggle */}
          {/* <div className='g_m_bottom_100 g_flex_h g_flex_left'>
            <input
              type='checkbox'
              id='isPromoterLevel'
              checked={!!isPromoterLevel}
              onChange={onIsPromoterLevelChange}
              style={{ marginRight: '8px' }}
            />
            <label htmlFor='isPromoterLevel' style={{ cursor: 'pointer' }}>
              Promoter-level document (separate upload per director)
            </label>
          </div> */}

          <SuccessMessageUI show={successMsg} message={successMsg} />
          <ErrorMessageUI errorList={errorList} />
        </div>

        <div className='move-to-cs-modal-footer'>
          <ButtonUI
            label='Cancel'
            onClick={onCancelClick}
            className='g_m_right_50'
            disabled={submitted}
          />
          <ButtonUI
            label={label}
            onClick={onSubmitClick}
            busy={submitted}
            primary={true}
            disabled={!title || typeof title !== 'string' || !title.trim() || submitted}
          />
        </div>

      </div>
    </div>
  )
}

export default AddCustomDocModalUI